import React from 'react';
import { Modal, Form, Button, Row } from 'react-bootstrap';
import { CloseButton } from '../../styles';
import TagsInput from 'react-tagsinput';
import { useTransmitirNFe } from '../../TransmitirNFeContext';
import {
  Container,
  ModalActionEmail,
  ContainerEmail,
  InputTagSt,
} from './styles';
import { AiOutlineClose } from 'react-icons/ai';
import { CircularProgress } from '@material-ui/core';

/**
 * ModalEmail
 * Modal para envio de DANFE por e-mail com suporte a múltiplos destinatários.
 * - Pressione Enter para confirmar cada e-mail no campo de tags.
 * - Botão "Enviar" habilita apenas quando há pelo menos 1 e-mail válido.
 */
export const ModalEmail: React.FC = () => {
  const {
    isOpenModalEmail,
    setIsOpenModalEmail,
    handleSendEmail,
    tags,
    setTags,
    loadingEmail,
  } = useTransmitirNFe();

  const handleCloseModal = () => {
    setIsOpenModalEmail(false);
  };

  /**
   * Filtra e normaliza a lista de e-mails recebida do componente de tags.
   * @param allEmails Lista bruta de e-mails
   */
  const handleEmail = (allEmails: string[]) => {
    const emailExp = /^\w+([-.]?\w+)*@\w+([-.]?\w+)*(\.\w{2,})+$/;
    const emails: string[] = [];
    for (let i = 0; i < allEmails.length; i++) {
      const candidate = allEmails[i]?.trim();
      if (candidate && emailExp.test(candidate)) {
        emails.push(candidate);
      }
    }
    setTags(emails);
  };

  return (
    <Container>
      <ModalActionEmail
        show={isOpenModalEmail}
        onHide={handleCloseModal}
        centered
        keyboard
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Enviar Danfe
          </Modal.Title>
          <CloseButton onClick={handleCloseModal} aria-label="Fechar modal">
            <AiOutlineClose size={24} />
          </CloseButton>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Row>
              <Form.Group controlId="emails" className="mb-3">
                <Form.Label>Pressione Enter para Confirmar</Form.Label>
                <InputTagSt>
                  <TagsInput
                    value={tags}
                    className="Tags"
                    onChange={handleEmail}
                    inputProps={{
                      placeholder: '',
                      id: 'emails',
                      'aria-label': 'E-mails para envio do DANFE',
                    }}
                  />
                </InputTagSt>
              </Form.Group>
            </Row>

            <Row>
              <ContainerEmail>
                <Button
                  className="btn-impressao"
                  onClick={handleSendEmail}
                  title="Enviar"
                  disabled={tags.length === 0}
                >
                  Enviar
                  {loadingEmail && (
                    <CircularProgress size={15} style={{ color: '#ffffff' }} />
                  )}
                </Button>

                <Button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleCloseModal}
                  title="Cancelar"
                >
                  Cancelar
                </Button>
              </ContainerEmail>
            </Row>
          </Form>
        </Modal.Body>
      </ModalActionEmail>
    </Container>
  );
};
